import { render, staticRenderFns } from "./SelectFilesWrapper.vue?vue&type=template&id=665d7386&scoped=true&"
import script from "./SelectFilesWrapper.vue?vue&type=script&lang=js&"
export * from "./SelectFilesWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SelectFilesWrapper.vue?vue&type=style&index=0&id=665d7386&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665d7386",
  null
  
)

export default component.exports